export const SceneKeys = {
  Boot: "BootScene",
  Preload: "PreloadScene",
  Game: "GameScene",
  HomeRoom: "HomeRoomScene",
  Tower: "TowerScene",
} as const;

export type SceneKey = (typeof SceneKeys)[keyof typeof SceneKeys];
